import { Card, CardBody } from "react-bootstrap";
import { useNavigate } from "react-router";

const AdminBlockLink = ({children, info}) => {
    const navigate=useNavigate();
    return(
        <>
        <Card onClick={()=>{navigate(info.link)}} className="mt-2 mb-2 audit_info_label_block">
            <CardBody>
                <h4 className="d-flex gap-2 align-items-baseline"><div>{children}</div><div>{info.label}</div></h4>
                <div className="text_font">{info.info_text}</div>
            </CardBody>
        </Card>
        </>
    )
}

export default AdminBlockLink;